import { useParams, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { FaShoppingCart, FaHeart, FaArrowLeft } from "react-icons/fa";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { addToCart } from "../features/cart/cartSlice"; // ✅ استدعاء الأكشن
import "../About.css";
import products from "../data/Products.json";

function ProductDetails({ wishlist, onAddToWishlist, onRemoveFromWishlist }) {
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch(); // ✅ تفعيل dispatch

  // 🟡 البحث عن المنتج
  const product = products.find((p) => p.id === parseInt(id));

  const [mainImage, setMainImage] = useState(
    product && product.images ? product.images[0] : product?.image || ""
  );

  if (!product) {
    return (
      <div className="container py-5 text-center">
        <h2>Product not found 😢</h2>
        <button
          className="btn btn-primary mt-3"
          onClick={() => navigate("/products")}
        >
          Back to Products
        </button>
      </div>
    );
  }

  // ✅ تحقق من إذا المنتج موجود فعلاً في المفضلة
  const isFavorite = wishlist.some((item) => item.id === product.id);

  // 🛒 إضافة للسلة عبر Redux
  const handleAddToCart = () => {
    dispatch(addToCart(product)); // ✅ يضيف المنتج فعليًا للكارت
    Swal.fire({
      icon: "success",
      title: "Added to Cart 🛒",
      text: `${product.name} has been added to your cart!`,
      showConfirmButton: false,
      timer: 2000,
    });
  };

  // ❤️ المفضلة (حقيقي متصل)
  const handleToggleFav = () => {
    if (isFavorite) {
      onRemoveFromWishlist(product.id);
      Swal.fire({
        icon: "info",
        title: "Removed from Favorites",
        text: `${product.name} removed from your favorites.`,
        showConfirmButton: false,
        timer: 1500,
      });
    } else {
      onAddToWishlist(product);
      Swal.fire({
        icon: "success",
        title: "Added to Favorites",
        text: `${product.name} added to your favorites.`,
        showConfirmButton: false,
        timer: 1500,
      });
    }
  };

  return (
    <div className="container py-5">
      {/* زر رجوع */}
      <button
        className="btn btn-outline-secondary mb-4"
        onClick={() => navigate(-1)}
      >
        <FaArrowLeft /> Back
      </button>

      <div className="row">
        {/* صورة المنتج */}
        <div className="col-md-6 text-center">
          <img
            src={mainImage}
            alt={product.name}
            className="img-fluid w-100 rounded shadow mb-3"
            style={{ maxHeight: "400px", objectFit: "contain" }}
          />

          {/* الصور الصغيرة */}
          {product.images && product.images.length > 1 && (
            <div className="d-flex justify-content-center gap-2">
              {product.images.map((img, idx) => (
                <img
                  key={idx}
                  src={img}
                  alt={`thumb-${idx}`}
                  className={`rounded border thumb-image ${
                    img === mainImage ? "active-thumb" : ""
                  }`}
                  style={{
                    width: "80px",
                    height: "80px",
                    objectFit: "cover",
                    cursor: "pointer",
                    border: "2px solid #ddd",
                  }}
                  onClick={() => setMainImage(img)}
                />
              ))}
            </div>
          )}
        </div>

        {/* تفاصيل المنتج */}
        <div className="col-md-6">
          <h2 className="fw-bold">{product.name}</h2>
          <p className="text-muted">{product.desc}</p>
          <h4 className="text-success mb-4">${product.price}</h4>

          <div className="d-flex gap-3">
            {/* ✅ Add to Cart (فعّال) */}
            <button
              className="btn btn-success d-flex align-items-center gap-2"
              onClick={handleAddToCart}
            >
              <FaShoppingCart /> Add to Cart
            </button>

            {/* ❤️ Favorites */}
            <button
              className="btn btn-outline-danger d-flex align-items-center gap-2"
              onClick={handleToggleFav}
            >
              <FaHeart
                style={{
                  color: isFavorite ? "red" : "gray",
                  transition: "0.3s",
                }}
              />{" "}
              {isFavorite ? "Remove Favorite" : "Add to Favorites"}
            </button>
          </div>

          <div className="mt-4">
            <h5>Category:</h5>
            <p>{product.category}</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ProductDetails;
